import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
  selector: 'mdwg-not-found',
  // template: './not-found.component.html',
  template: `
  <div class="mdwg-div mobi-content" style="color: red;">
  <div style="background-color: white;">
    <p style="color: red;">
      The page you are trying to reach was not found.
    </p>
    <p style="background-color: white; color: gray;" 
    *ngIf="path">Perhaps you are trying to reach the page: <a [routerLink]="path">"{{ path }}" </a></p>
    </div>
  </div>
`,
styleUrls: ['./not-found.component.scss']

})
export class NotFoundComponent implements OnInit {
  path: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.data.pipe(take(1))
      .subscribe((data: { path: string }) => {
        this.path = data.path;
      });
  }
}